<template>
  <div :class="`articleViewBox`" :style="{
    'background': data.infoItme.bjColor,
    'padding': `${data.infoItme.sBj} ${data.infoItme.yeBj} ${data.infoItme.xBj}`
  }">
    <el-tabs v-model="activeName">
      <el-tab-pane label="全部" name="1">
        <div class="news-wrap">
          <div :class="`layout-one layout${data.neiRadio} card${data.conValue}`">
            <ul>
              <li v-for="(item, index) in dataList" :key="index"
                :style="{ 'border-radius': data.bianjiaoRadio === '直角' ? '0px' : '8px' }">
                <div :class="`imgs`" v-if="data.neiRadio !== '1'">
                  <div :class="`scace${scace}`">
                    <img v-if="item.uploadfiles" :src="item.uploadfiles" alt="">
                    <img v-else src="../../assets/image-upload.jpg" alt="">
                  </div>
                </div>
                <div class="text">
                  <h3 class="ellipsis" :style="{ 'font-weight': data.boldRadio === '有' ? 'bold' : 'normal' }">{{
                    item.title }}</h3>
                  <div class="time">
                    {{ item.created_at }}
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="挖掘机械" name="2">配置管理</el-tab-pane>
      <el-tab-pane label="环卫机械" name="3">角色管理</el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
export default {
  name: 'articleListView',
  props: {
    data: Object
  },
  data () {
    return {
      activeName: '1',
      scace: '1',
      dataList: [
        {
          id: 136,
          slug: '136',
          cid: 2,
          title: '成套装备奋战在徐州除雪一线',
          uploadfiles:
            '//cdn.myxypt.com/3c4f22d1/24/09/8436aa9bd0fc4f672786ec913652ca14e376ea7c.png',
          content:
            '<p style="text-align: center;"><img src="//cdn.myxypt.com/3c4f22d1/24/09/f86f55cf01ebd3241ddea6720d2d674dd5e321fd.jpg"/></p>',
          timeline: 1725497904,
          isgood: 0,
          flag: 1,
          istop: 0,
          hits: 2,
          orders: 22,
          ctitle: '',
          cdescription: '',
          level: 0,
          description: '',
          name: '成套装备奋战在徐州除雪一线',
          media: [
            {
              type: 'image',
              url:
                '//cdn.myxypt.com/3c4f22d1/24/09/8436aa9bd0fc4f672786ec913652ca14e376ea7c.png'
            }
          ],
          summary: '',
          created_at: '2024-09-05 08:58:24',
          cate: {
            cid: 2,
            slug: '2',
            cname: '环卫机械',
            word: null,
            parentid: 0,
            depth: 0,
            orders: 2,
            flag: 1,
            intro: '',
            timeline: 1665447957,
            elite: 0,
            img: '',
            linktype: 1,
            linkurl: '',
            target: 1,
            content: null,
            title: '',
            description: '',
            banner: '',
            id: 2,
            name: '环卫机械'
          }
        },
        {
          id: 135,
          slug: '135',
          cid: 2,
          title: '高压清洗车在江苏徐州作业',
          uploadfiles:
            '//cdn.myxypt.com/3c4f22d1/24/09/18d9b37495cb88a624930271df28063af56a8996.png',
          content:
            '<p><img src="//cdn.myxypt.com/3c4f22d1/24/09/9678602815c572919bf412a686739b2e78beb8a9.jpg"/></p>',
          timeline: 1725497729,
          isgood: 0,
          flag: 1,
          istop: 0,
          hits: 0,
          orders: 21,
          ctitle: '',
          cdescription: '',
          level: 0,
          description: '',
          name: '高压清洗车在江苏徐州作业',
          media: [
            {
              type: 'image',
              url:
                '//cdn.myxypt.com/3c4f22d1/24/09/18d9b37495cb88a624930271df28063af56a8996.png'
            }
          ],
          summary: '',
          created_at: '2024-09-05 08:55:29',
          cate: {
            cid: 2,
            slug: '2',
            cname: '环卫机械',
            word: null,
            parentid: 0,
            depth: 0,
            orders: 2,
            flag: 1,
            intro: '',
            timeline: 1665447957,
            elite: 0,
            img: '',
            linktype: 1,
            linkurl: '',
            target: 1,
            content: null,
            title: '',
            description: '',
            banner: '',
            id: 2,
            name: '环卫机械'
          }
        },
        {
          id: 134,
          slug: '134',
          cid: 2,
          title: '吸污车在西藏清洁作业',
          uploadfiles:
            '//cdn.myxypt.com/3c4f22d1/24/09/9b031e57cc7ad3d8ed993c0ceeeafa785a1f5c4b.png',
          content:
            '<p style="text-align: center;"><img src="//cdn.myxypt.com/3c4f22d1/24/09/f163accabd6af32c9d7883ab918d770f17554f73.jpg"/></p>',
          timeline: 1725497621,
          isgood: 0,
          flag: 1,
          istop: 0,
          hits: 1,
          orders: 20,
          ctitle: '',
          cdescription: '',
          level: 0,
          description: '',
          name: '吸污车在西藏清洁作业',
          media: [
            {
              type: 'image',
              url:
                '//cdn.myxypt.com/3c4f22d1/24/09/9b031e57cc7ad3d8ed993c0ceeeafa785a1f5c4b.png'
            }
          ],
          summary: '',
          created_at: '2024-09-05 08:53:41',
          cate: {
            cid: 2,
            slug: '2',
            cname: '环卫机械',
            word: null,
            parentid: 0,
            depth: 0,
            orders: 2,
            flag: 1,
            intro: '',
            timeline: 1665447957,
            elite: 0,
            img: '',
            linktype: 1,
            linkurl: '',
            target: 1,
            content: null,
            title: '',
            description: '',
            banner: '',
            id: 2,
            name: '环卫机械'
          }
        },
        {
          id: 133,
          slug: '133',
          cid: 2,
          title: '墙面清洗车在上海打浦路隧道作业',
          uploadfiles:
            '//cdn.myxypt.com/3c4f22d1/24/09/b8c07d83db668e3fcc65161e9149c356802f7260.png',
          content:
            '<p style="text-align: center;"><img src="//cdn.myxypt.com/3c4f22d1/24/09/db730136dd96c14317754587fa65cc7cafafc489.jpg"/></p>',
          timeline: 1725497425,
          isgood: 0,
          flag: 1,
          istop: 0,
          hits: 0,
          orders: 19,
          ctitle: '',
          cdescription: '',
          level: 0,
          description: '',
          name: '墙面清洗车在上海打浦路隧道作业',
          media: [
            {
              type: 'image',
              url:
                '//cdn.myxypt.com/3c4f22d1/24/09/b8c07d83db668e3fcc65161e9149c356802f7260.png'
            }
          ],
          summary: '',
          created_at: '2024-09-05 08:50:25',
          cate: {
            cid: 2,
            slug: '2',
            cname: '环卫机械',
            word: null,
            parentid: 0,
            depth: 0,
            orders: 2,
            flag: 1,
            intro: '',
            timeline: 1665447957,
            elite: 0,
            img: '',
            linktype: 1,
            linkurl: '',
            target: 1,
            content: null,
            title: '',
            description: '',
            banner: '',
            id: 2,
            name: '环卫机械'
          }
        },
        {
          id: 132,
          slug: '132',
          cid: 1,
          title: '联袂出击！中大挖奏响新能源产业发展新序曲',
          uploadfiles:
            '//cdn.myxypt.com/3c4f22d1/24/09/a4d4d585b35c12367da9de33ddf8321e2ab7eda3.png',
          content:
            '<p style="text-indent: 2em;">在距惠州大亚湾石化区半小时车程之外，坐落着惠州比亚迪大亚湾工业园，作为比亚迪集团全球战略新兴产业基地之一，如今，这座基地扩张的“进度条”再度刷新，第四期工程已进入建设冲刺期，而目前担当施工主力的正是“钢铁军团”。</p><p><br/></p><p style="text-indent: 2em;">项目建设现场，机械轰鸣声不绝于耳，四十余台挖掘机来回穿梭，井然有序地进行破碎与装车作业。比亚迪工业园依山而建，土石方量高达600万方，为完成这一浩大的“移山”工程，20-70吨级挖掘机联袂出击，以施工“组合拳”为项目建设跑出“加速度”。</p><p><br/></p><p style="text-indent: 2em;"><img src="//cdn.myxypt.com/3c4f22d1/24/09/889cd4a82909f41438c111a98bcb564b254b1b57.jpg"/></p><p><br/></p><p style="text-indent: 2em;">移山需平地，项目现场多为麻石，即花岗岩，质地坚硬，是出了名的“难啃的硬骨头”，而负责攻克此项重任的，正是50-70吨级大吨位挖掘机。据客户称，原先使用的并不是挖掘机，随着破碎作业的逐渐深入，才逐渐更换成了。</p><p><br/></p><p style="text-indent: 2em;">这边岩石硬的很，后期破碎特别吃力，在工作人员的推荐下，我们尝试了大吨位挖掘机，果真像鸡蛋碰石头，一碰就碎，于是后面我们陆陆续续都置换成了。</p><p><br/></p><p style="text-indent: 2em;">大挖经过一系列迭代升级，整机更加稳定高效，以2023年“中国工程机械行业TOP50市场表现金奖”获得者——XE650GK为例，采用新一代智能电控系统，整机能效提升7%-10%，已成为全国各类露天矿山开采的首选设备。</p><p><br/></p><p style="text-indent: 2em;">650开到现在最大的感触就是稳重顺手，操作杆比其他挖机要好，配重敦实，不翘屁股，油耗也不算大，40升油，还是比较经济实惠的。”对此，客户称赞道。</p><p><br/></p><p style="text-indent: 2em;">与破碎同时进行的，是中大挖的装车作业。客户表示，“现场工况比较复杂，石方作业我们选择的是370和380，配备1.9m³铲斗，重载施工更高效；而对于土方以及其他的一些清表作业，我们选择的是200，整机协调性更强，动作也更加灵活。”</p><p><br/></p><p style="text-indent: 2em;">在协同作业中，各个吨位、不同型号的挖掘机爆发出了惊人的能量。据客户表示，挖掘机目前可实现月产15万方，目测到明年项目结束，将超额完成施工任务。在如今的中国大地上，一座座新能源产业基地拔地而起，融入全球新能源产业变革的庞大合奏当中。挖机将以行业领先的技术创新实力，为全国用户提供“更高效、更可靠、更经济”的一体化施工解决方案，彰显国之重器的使命担当。</p><p><br/></p>',
          timeline: 1725497379,
          isgood: 0,
          flag: 1,
          istop: 0,
          hits: 1,
          orders: 18,
          ctitle: '',
          cdescription: '',
          level: 0,
          description: '',
          name: '联袂出击！中大挖奏响新能源产业发展新序曲',
          media: [
            {
              type: 'image',
              url:
                '//cdn.myxypt.com/3c4f22d1/24/09/a4d4d585b35c12367da9de33ddf8321e2ab7eda3.png'
            }
          ],
          summary: '',
          created_at: '2024-09-05 08:49:39',
          cate: {
            cid: 1,
            slug: '1',
            cname: '挖掘机械',
            word: 'gjdwcd4',
            parentid: 0,
            depth: 0,
            orders: 1,
            flag: 1,
            intro: '',
            timeline: 1623033270,
            elite: 0,
            img: '',
            linktype: 1,
            linkurl: '',
            target: 1,
            content: null,
            title: '',
            description: '',
            banner: '',
            id: 1,
            name: '挖掘机械'
          }
        },
        {
          id: 131,
          slug: '131',
          cid: 1,
          title: '万亿增发国债首批项目落地，这个领域掀起建设热潮！',
          uploadfiles:
            '//cdn.myxypt.com/3c4f22d1/24/09/14a6d8c913a5327949118fa1daa2dcee7be766c1.png',
          content:
            '<p style="text-align: center;">40余台XE200GH挖掘机，在贵州毕节赫章雉街彝族苗族乡韭菜坪进行高标准农田建设。</p><p><br/></p><p style="text-align: center;">以“贵州屋脊”为“画布”，挖掘机在云端“绘”良田。</p><p><br/></p><p style="text-align: center;">项目负责人周总表示，“我们采购的挖掘机数量已经达到40台，目前的施工基本就在山上面，（XE200GH）不需要添加尿素，省去了（尿素）上山的麻烦。”<br/></p><p><br/></p><p style="text-align: center;"><img src="//cdn.myxypt.com/3c4f22d1/24/09/9f0bc97cd01a6a4ddb4ade91f3b0091d83fd7537.jpg"/></p><p><br/></p><p style="text-align: center;">“采购以后，我们对于挖掘机的油耗、操作性能做了试验，当前工况下（XE200GH）一个小时的油耗在11L左右，对所有驾驶员的回访也显示，国四挖掘机的操控性能更优越。”</p><p><br/></p><p style="text-align: center;">现场施工的陆师傅说，“目前施工的地方海拔有两三千米，修路、场地平整，能干的项目很多。（XE200GH）开起还是蛮舒服的，这个座椅坐起来蛮好的，速度也快，动作也蛮协调的，比较省油，不管多晚，给侯师傅（服务工程师）发信息都有回复，有什么问题随时就解决了。”<br/></p><p><br/></p><p style="text-align: center;">在“天府粮仓”四川眉山仁寿县方家镇，数台XE135GA挖掘机正有条不紊地在田间地头来回作业，将大小不一、分散不均的地块聚拢推平，一块块规范的高标准农田初具雏形。现场操作机手表示，“（挖掘机）主要是搞人工替代，目前我们正在对农田进行小田改大田、坡地改平地、开挖沟渠等工作，XE135GA动作协调，速度比较快，爬坡非常有力。”<br/></p><p><br/></p><p style="text-align: center;">现场的项目负责人表示，“高标准农田建设离不开农业机械化率的提高，挖掘机在项目上，就是按期完工的保障。”<br/></p><p><br/></p>',
          timeline: 1725497211,
          isgood: 0,
          flag: 1,
          istop: 0,
          hits: 1,
          orders: 17,
          ctitle: '',
          cdescription: '',
          level: 0,
          description: '',
          name: '万亿增发国债首批项目落地，这个领域掀起建设热潮！',
          media: [
            {
              type: 'image',
              url:
                '//cdn.myxypt.com/3c4f22d1/24/09/14a6d8c913a5327949118fa1daa2dcee7be766c1.png'
            }
          ],
          summary: '',
          created_at: '2024-09-05 08:46:51',
          cate: {
            cid: 1,
            slug: '1',
            cname: '挖掘机械',
            word: 'gjdwcd4',
            parentid: 0,
            depth: 0,
            orders: 1,
            flag: 1,
            intro: '',
            timeline: 1623033270,
            elite: 0,
            img: '',
            linktype: 1,
            linkurl: '',
            target: 1,
            content: null,
            title: '',
            description: '',
            banner: '',
            id: 1,
            name: '挖掘机械'
          }
        },
        {
          id: 130,
          slug: '130',
          cid: 2,
          title: '无人驾驶扫路机在徐州珠山艺术街区作业',
          uploadfiles:
            '//cdn.myxypt.com/3c4f22d1/24/09/4ebefe3461bbed462dc624ef54975f85f8c26ffb.png',
          content:
            '<p style="text-align: center;"><img src="//cdn.myxypt.com/3c4f22d1/24/09/aad8ec8b5c03b9cbd40ac1184d625df61626880c.jpg"/></p>',
          timeline: 1725497131,
          isgood: 0,
          flag: 1,
          istop: 0,
          hits: 3,
          orders: 16,
          ctitle: '',
          cdescription: '',
          level: 0,
          description: '',
          name: '无人驾驶扫路机在徐州珠山艺术街区作业',
          media: [
            {
              type: 'image',
              url:
                '//cdn.myxypt.com/3c4f22d1/24/09/4ebefe3461bbed462dc624ef54975f85f8c26ffb.png'
            }
          ],
          summary: '',
          created_at: '2024-09-05 08:45:31',
          cate: {
            cid: 2,
            slug: '2',
            cname: '环卫机械',
            word: null,
            parentid: 0,
            depth: 0,
            orders: 2,
            flag: 1,
            intro: '',
            timeline: 1665447957,
            elite: 0,
            img: '',
            linktype: 1,
            linkurl: '',
            target: 1,
            content: null,
            title: '',
            description: '',
            banner: '',
            id: 2,
            name: '环卫机械'
          }
        },
        {
          id: 129,
          slug: '129',
          cid: 2,
          title: '吸污车驰援郑州特大暴雨',
          uploadfiles:
            '//cdn.myxypt.com/3c4f22d1/24/09/04a77ca47d024ef43434df3ab650bd09b4166b16.jpg',
          content:
            '<p style="text-align: center;"><img src="//cdn.myxypt.com/3c4f22d1/24/09/04a77ca47d024ef43434df3ab650bd09b4166b16.jpg"/></p><p style="line-height: 2em;"><span style="text-wrap: nowrap;">&nbsp; &nbsp; </span>&nbsp; 2021年，7月20日，河南遭遇极端持续强降雨，内涝灾情牵动着全国人民的心。环境迅速组建排涝突击队，并调集多台管网维护及排涝装备，连夜赶赴现场，紧急驰援郑州，风雨面前一起扛。</p><p style="line-height: 2em;">&nbsp; &nbsp; &nbsp; &nbsp;生命为号，灾情为令。联合疏通车、挖掘抽吸车等多台管网维护及排涝装备、20余名操作人员及技术人员，按照公司统一部署，已于7月22日凌晨顺利抵达河南郑州，24小时现场待命，全力保障紧急排水工作。</p><p style="line-height: 2em;">&nbsp; &nbsp; &nbsp; &nbsp;暴雨涨水冲刷产生的泥沙、杂物等导致郑州城区居民小区的地下管网严重瘀堵，联合疏通车接管平铺50-200米，垂直13-50米抽吸排水，全力保障居民小区、电梯井、地下车库及地下室安全，防止雨灾后续的次生灾害。</p><p><br/></p>',
          timeline: 1725497052,
          isgood: 0,
          flag: 1,
          istop: 0,
          hits: 3,
          orders: 15,
          ctitle: '',
          cdescription: '',
          level: 0,
          description: '',
          name: '吸污车驰援郑州特大暴雨',
          media: [
            {
              type: 'image',
              url:
                '//cdn.myxypt.com/3c4f22d1/24/09/04a77ca47d024ef43434df3ab650bd09b4166b16.jpg'
            }
          ],
          summary: '',
          created_at: '2024-09-05 08:44:12',
          cate: {
            cid: 2,
            slug: '2',
            cname: '环卫机械',
            word: null,
            parentid: 0,
            depth: 0,
            orders: 2,
            flag: 1,
            intro: '',
            timeline: 1665447957,
            elite: 0,
            img: '',
            linktype: 1,
            linkurl: '',
            target: 1,
            content: null,
            title: '',
            description: '',
            banner: '',
            id: 2,
            name: '环卫机械'
          }
        },
        {
          id: 128,
          slug: '128',
          cid: 1,
          title: '为客户“量身定制”10000000m³土石方解决方案',
          uploadfiles:
            '//cdn.myxypt.com/3c4f22d1/24/09/5ce2f7e20b807a901b0be03cea8b975f236e2c02.png',
          content:
            '<p style="text-align: center;">贵州遵义长岭特殊钢精深加工技改项目为贵州省2023年重点项目，土石方平场量1000多万方，在整个建设过程中，挖机为客户“量身定制”租赁、施工、服务保障方案。<br/></p><p><br/></p><p style="text-align: center;">综合考虑该土石方平场项目的周期和设备数量，客户决定选择“租赁”业务模式。挖机租赁团队经过调研、计算，根据挖装、破碎不同的施工场景，提供了性价比最高的租赁方案，切实提高作业效率。<br/></p><p><br/></p><p style="text-align: center;">该土石方平场项目，前期施工关键词是“挖装”，后期施工关键词是“破碎”，挖机从需求出发，为客户定制不同的施工解决方案。</p><p style="text-align: center;">前期爆破剥离工序后，20吨挖掘机搭配140的小破碎锤进行二破，同时XE380GK、XE600GK等机型进行挖装作业。现场共投入挖掘机50多台，每天的挖方量在10万方左右。</p><p><br/></p><p style="text-align: center;"><img src="//cdn.myxypt.com/3c4f22d1/24/09/5bf9074ceaae236c1c6245d859f61c6039caf6e3.jpg"/></p><p><br/></p><p style="text-align: center;">根据自卸车规格及装车位置，挖机为客户提供合适的机型。</p><p><br/></p><p style="text-align: center;">XE380GK搭配渣土车，装车效率高，XE600GK则搭配装载量更大的宽体车，实现更高的综合效率。客户对于整个挖装方案很满意，“像XE380GK这款产品，整体油耗和挖装的速度，都优于以前的老产品。”</p><p><br/></p><p style="text-align: center;">除了为客户提供机型配置方案、挖掘机与自卸车的配合方案，挖机相关负责人表示，“我们还根据平场的物料特点，为客户选择了合适的铲斗、斗齿、钎杆、履带板等部件。”</p><p style="text-align: left;"><br/></p><p style="text-align: center;">平场后期施工关键词是“破碎”。项目有230万方土石方，因为靠近高速，无法爆破，要采取机械破碎的模式。</p><p><br/></p><p style="text-align: center;">挖机给客户推荐的方案是，20余台50吨、60吨级挖掘机，配200或210的破碎锤，进行机械破碎施工。</p><p><br/></p><p style="text-align: center;">客户对出方效率很满意，“拿XE600GK来说，它可以针对软岩、硬岩自动调节功率，针对软岩提升打击频率，针对硬岩保证破碎效率，省油高效，不耽误工期。”</p><p style="text-align: center;">整个施工周期，挖机投入设备保障车辆4辆，包含1辆综合服务车，拥有焊接、发电等全功能；设置两个仓库，储备整个工地百余台设备的备件，备件前移到工地，快速响应，保证设备投产效益；同时配备多名服务人员，服务大区经理专项专抓，高度重视，5分钟响应，两小时解决问题，24小时都能保证施工效率。<br/></p><p><br/></p><p style="text-align: center;">扑下身子，为客户定制解决方案的过程中，挖机已悄然实现“升维竞争”，为客户提供全价值链、全生命周期的产品和服务，不断占领市场“价值高地”。<br/></p><p><br/></p>',
          timeline: 1725497043,
          isgood: 0,
          flag: 1,
          istop: 0,
          hits: 1,
          orders: 14,
          ctitle: '',
          cdescription: '',
          level: 0,
          description: '',
          name: '为客户“量身定制”10000000m³土石方解决方案',
          media: [
            {
              type: 'image',
              url:
                '//cdn.myxypt.com/3c4f22d1/24/09/5ce2f7e20b807a901b0be03cea8b975f236e2c02.png'
            }
          ],
          summary: '',
          created_at: '2024-09-05 08:44:03',
          cate: {
            cid: 1,
            slug: '1',
            cname: '挖掘机械',
            word: 'gjdwcd4',
            parentid: 0,
            depth: 0,
            orders: 1,
            flag: 1,
            intro: '',
            timeline: 1623033270,
            elite: 0,
            img: '',
            linktype: 1,
            linkurl: '',
            target: 1,
            content: null,
            title: '',
            description: '',
            banner: '',
            id: 1,
            name: '挖掘机械'
          }
        },
        {
          id: 127,
          slug: '127',
          cid: 2,
          title: '多功能抑尘车在河北正定喷洒消毒液',
          uploadfiles:
            '//cdn.myxypt.com/3c4f22d1/24/09/b33c4b5a453a8c072a0f13c1e7c47c0ab690d0c0.jpg',
          content:
            '<p style="text-align: center;"><img src="//cdn.myxypt.com/3c4f22d1/24/09/b33c4b5a453a8c072a0f13c1e7c47c0ab690d0c0.jpg"/></p><p>在夜色下，正定的桥、树、城楼与雾炮车相互辉映，形成了立体的画卷之美。</p><p><br/></p><p>晚上10点多，在减少对居民影响的前提下，正定环卫部门出动46辆特种车车辆，其中包括5辆雾炮车，对县城范围内所有的大小道路、公园广场、游园节点、停车场、农村等</p><p>区域喷洒消毒剂。</p><p><br/></p>',
          timeline: 1725496870,
          isgood: 0,
          flag: 1,
          istop: 0,
          hits: 2,
          orders: 13,
          ctitle: '',
          cdescription: '',
          level: 0,
          description: '',
          name: '多功能抑尘车在河北正定喷洒消毒液',
          media: [
            {
              type: 'image',
              url:
                '//cdn.myxypt.com/3c4f22d1/24/09/b33c4b5a453a8c072a0f13c1e7c47c0ab690d0c0.jpg'
            }
          ],
          summary: '',
          created_at: '2024-09-05 08:41:10',
          cate: {
            cid: 2,
            slug: '2',
            cname: '环卫机械',
            word: null,
            parentid: 0,
            depth: 0,
            orders: 2,
            flag: 1,
            intro: '',
            timeline: 1665447957,
            elite: 0,
            img: '',
            linktype: 1,
            linkurl: '',
            target: 1,
            content: null,
            title: '',
            description: '',
            banner: '',
            id: 2,
            name: '环卫机械'
          }
        },
        {
          id: 126,
          slug: '126',
          cid: 1,
          title: '世纪工程！百台挖掘机助建西部陆海新通道',
          uploadfiles:
            '//cdn.myxypt.com/3c4f22d1/24/09/e5e3be954fad1f152b66be9c91586c142b5cdcf6.jpg',
          content:
            '<p style="text-align: center;">南钦渠道，丝路交响</p><p style="text-align: center;">&nbsp;通江达海，陆海相融</p><p style="text-align: center;">桂南大地上</p><p style="text-align: center;">百余台挖掘机尽显担当</p><p style="text-align: center;">&nbsp;&nbsp;助力打通广西水运“任督二脉”</p><p style="text-align: center;">&nbsp; &nbsp; &nbsp; &nbsp;此次挖掘机参建的平陆运河项目位于广西南部，是我国自京杭大运河后一千多年来的第一条运河，是“广西所盼，桂运所系”的世纪工程。</p><p><br/></p><p style="text-align: center;"><img src="//cdn.myxypt.com/3c4f22d1/24/09/a5b354f3478745035ec0c01d20389fdc9ac2196a.jpg"/></p><p><br/></p><p style="text-align: center;">&nbsp; &nbsp; &nbsp; &nbsp;平陆运河建成后，将直接连通西江航运干线和北部湾海港，从根本上缓解西江下游通航压力，大幅提升西部陆海新通道运输能力，促进新时代西部大开发形成新格局。</p><p style="text-align: center;">&nbsp; &nbsp; &nbsp; &nbsp;据了解，平陆运河项目今年5月已全线动工，百余台大吨位挖掘机作为“开河先锋”，在施工现场往来穿梭，高效推进路面、便道的修筑，保障施工顺利推进。</p><p style="text-align: center;">&nbsp; &nbsp; &nbsp; &nbsp;项目负责人表示：“自挖掘机进驻已来，设备一直处于连轴转的状态，每天24小时作业不停歇，在这种高强度的状态中，挖掘机也没有出现过任何问题，已然成为项目施工主力军。”<br/></p><p style="text-align: center;">&nbsp; &nbsp; &nbsp; &nbsp;平陆运河全长135公里，共15个标段，难度最大的是马道、企石、青年3座梯级枢纽工程，需要消纳土方量4000多万立方米，工程量大、施工要求复杂，对于挖掘机的作业能力、工作效率以及出勤率都有极高要求。</p><p style="text-align: center;">&nbsp; &nbsp; &nbsp; &nbsp;“梯级枢纽这块会有一些山头的开挖以及风化石的搬运，为了达到最佳施工效果，我们选择了设备性能更强的60吨级大挖，配备3.6-4.5方的斗容，挖掘力更大，施工更高效，我们很放心。”<br/></p><p style="text-align: center;">&nbsp; &nbsp; &nbsp; &nbsp;挖掘机高效、可靠的品质赢得了施工方的高度认可，客户表示，后续将引入更多设备，以满足现场多样化的施工需求。</p><p style="text-align: center;">&nbsp; &nbsp; &nbsp; &nbsp;为确保项目顺利进行，在当地专门设立了服务保障中心，常驻的服务技术人员、充足的备件储备，为设备高效稳定运行提供强有力的保障。<br/></p><p style="text-align: center;">&nbsp; &nbsp; &nbsp; &nbsp;作为大国重器的顶梁柱，以“护卫者”的角色为本次平陆运河项目保驾护航，有条不紊地推进这一宏伟工程的各个建设节点，助力“蓝丝带”通江达海。未来，将持续以优质产品与专业服务投身国家重点工程建设，为推动高质量发展贡献力量！<br/></p><p><br/></p>',
          timeline: 1725496844,
          isgood: 0,
          flag: 1,
          istop: 0,
          hits: 1,
          orders: 12,
          ctitle: '',
          cdescription: '',
          level: 0,
          description: '',
          name: '世纪工程！百台挖掘机助建西部陆海新通道',
          media: [
            {
              type: 'image',
              url:
                '//cdn.myxypt.com/3c4f22d1/24/09/e5e3be954fad1f152b66be9c91586c142b5cdcf6.jpg'
            }
          ],
          summary: '',
          created_at: '2024-09-05 08:40:44',
          cate: {
            cid: 1,
            slug: '1',
            cname: '挖掘机械',
            word: 'gjdwcd4',
            parentid: 0,
            depth: 0,
            orders: 1,
            flag: 1,
            intro: '',
            timeline: 1623033270,
            elite: 0,
            img: '',
            linktype: 1,
            linkurl: '',
            target: 1,
            content: null,
            title: '',
            description: '',
            banner: '',
            id: 1,
            name: '挖掘机械'
          }
        },
        {
          id: 125,
          slug: '125',
          cid: 2,
          title: '多功能抑尘车搭载世界第二大运输机空运至卡塔尔',
          uploadfiles:
            '//cdn.myxypt.com/3c4f22d1/24/09/64520a8d54c8c463aa4a840a1c614bbbad2151bb.jpg',
          content:
            '<p style="text-align: center;">&nbsp; &nbsp; &nbsp;<img src="//cdn.myxypt.com/3c4f22d1/24/09/64520a8d54c8c463aa4a840a1c614bbbad2151bb.jpg"/></p><p>&nbsp;</p><p>&nbsp;&nbsp; &nbsp; 多功能抑尘车，又称“雾炮车”，具有喷雾降尘和清洗两大功能。通过在水中加入一定比例的消毒液，可立即启用“消毒”功能，在疫情防控时期作为新的消毒设备。</p><p style="line-height: 2em;">&nbsp; &nbsp; &nbsp; &nbsp;作业过程中，多功能抑尘车通过高压将一定科学比例的消毒水进行雾化并从风筒中喷射，喷洒后快速挥发，对环境无害。该产品能够充分发挥灵活机动作业快、水珠细密渗透力强、喷洒有力射程远等优势，确保全覆盖、零死角对重点区域进行消毒、杀菌。</p><p><br/></p>',
          timeline: 1725496709,
          isgood: 0,
          flag: 1,
          istop: 0,
          hits: 6,
          orders: 11,
          ctitle: '',
          cdescription: '',
          level: 0,
          description: '',
          name: '多功能抑尘车搭载世界第二大运输机空运至卡塔尔',
          media: [
            {
              type: 'image',
              url:
                '//cdn.myxypt.com/3c4f22d1/24/09/64520a8d54c8c463aa4a840a1c614bbbad2151bb.jpg'
            }
          ],
          summary: '',
          created_at: '2024-09-05 08:38:29',
          cate: {
            cid: 2,
            slug: '2',
            cname: '环卫机械',
            word: null,
            parentid: 0,
            depth: 0,
            orders: 2,
            flag: 1,
            intro: '',
            timeline: 1665447957,
            elite: 0,
            img: '',
            linktype: 1,
            linkurl: '',
            target: 1,
            content: null,
            title: '',
            description: '',
            banner: '',
            id: 2,
            name: '环卫机械'
          }
        }
      ]
    }
  },
  watch: {
    'data.biliRadio': function (newVal) {
      if (this.data.biliRadio === '1:1') {
        this.scace = '1'
      } else if (this.data.biliRadio === '4:3') {
        this.scace = '2'
      } else if (this.data.biliRadio === '2:1') {
        this.scace = '4'
      } else {
        this.scace = '3'
      }
    }
  },
  methods: {},
  mounted () {
    console.log('初始数据1111', this.data)
  }
}
</script>

<style scoped>
.news-wrap {
  padding: 15px 15px 0;
}

.news-wrap li {
  position: relative;
  margin-bottom: 10px;
  overflow: hidden;
}

.news-wrap li::before {
  content: "";
  display: block;
  width: 100%;
  height: 100%;
  z-index: 10;
  border: 1px solid transparent;
  background: none;
  position: absolute;
  left: 0;
  top: 0;
  box-sizing: border-box;
  border-radius: inherit;
}

.news-wrap .layout-one li:before {
  border-bottom: 1px solid #e8e8e8;
}

.news-wrap .text {
  padding: 15px;
}

.news-wrap .text h3 {
  font-size: 15px;
  color: #111;
  margin: 0;
  font-weight: 400;
  line-height: 20px;
}

.news-wrap .text .time {
  font-size: 12px;
  color: #666;
  line-height: 16px;
  margin-top: 12px;
}

/deep/ .el-tabs__header {
  margin: 0;
  padding: 0 15px;
}

.news-wrap .imgs {
  position: relative;
}

.news-wrap .imgs img {
  display: block;
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
  position: absolute;
  left: 0;
  top: 0;
  border-radius: inherit;
}

.layout2 .imgs {
  width: 100%;
}

.scace1 {
  position: relative;
  padding: 0 0 100% 0;
  border-radius: inherit;
}

.layout2 .scace4 {
  padding: 0 0 50% 0;
}

.layout3 .scace2 {
  padding: 0 0 75% 0;
}

.layout3 .scace3 {
  padding: 0 0 66.66% 0;
}

.layout3 ul {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
}

.layout3 li {
  overflow: hidden;
  width: calc(50% - 6px);
}

.layout4 .imgs {
  float: left;
  width: 32%;
  border-bottom-left-radius: inherit;
  border-top-right-radius: 0;
}

.layout4 .text {
  float: right;
  margin-left: 20px;
  width: calc(68% - 20px);
  padding: 20px 15px 10px 0;
}

.layout5 .imgs {
  float: right;
  width: 32%;
  border-top-left-radius: 0;
  border-bottom-right-radius: inherit;
}

.layout5 .text {
  float: left;
  margin-right: 20px;
  width: calc(68% - 20px);
  padding: 20px 0 10px 15px;
}

.news-wrap .card1 li {
  background: none;
}

.news-wrap .card2 li {
  background: #fff;
  box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.1);
}

.news-wrap .card3 li {
  background: #fff;
}

.news-wrap .card3 li:before {
  border: 1px solid #e8e8e8;
}

.news-wrap .card4 li {
  background: none;
}

.news-wrap .card4 li .text {
  padding-left: 0;
  padding-right: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/article/articleListView.vue